import { cn } from '@/lib/utils';

interface AppleCardAlertProps {
  open: boolean;
  type?: 'alert' | 'confirm';
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onClose: () => void;
  onConfirm?: () => void;
}

export function AppleCardAlert({
  open,
  type = 'alert',
  title,
  message,
  confirmText = '确定',
  cancelText = '取消',
  onClose,
  onConfirm,
}: AppleCardAlertProps) {
  if (!open) return null;

  const handleConfirm = () => {
    onConfirm?.();
    onClose();
  };

  return (
    <div
      className={cn(
        'fixed inset-0 z-[100] flex items-center justify-center p-5 transition-all duration-200',
        'bg-black/55 backdrop-blur-md opacity-100'
      )}
      onClick={onClose}
    >
      <div
        className={cn(
          'w-full max-w-[340px] rounded-2xl bg-white p-6 text-center backdrop-blur-xl shadow-[0_24px_70px_-12px_rgba(0,0,0,0.5)] border border-white/80 transition-all duration-200',
          'scale-100 opacity-100 translate-y-0'
        )}
        style={{ backgroundColor: 'rgba(255,255,255,0.98)' }}
        onClick={(e) => e.stopPropagation()}
      >
        {title && (
          <h3 className="text-[17px] font-semibold text-zinc-900 leading-tight mb-2">
            {title}
          </h3>
        )}
        <p className="text-[14px] leading-relaxed text-zinc-500">
          {message}
        </p>

        <div className={cn('mt-6 flex gap-3', type === 'confirm' ? 'flex-row' : 'flex-col items-center')}>
          {type === 'confirm' && (
            <button
              onClick={onClose}
              className="flex-1 h-11 rounded-xl bg-zinc-100 text-zinc-700 text-[15px] font-medium hover:bg-zinc-200 transition-colors"
            >
              {cancelText}
            </button>
          )}
          <button
            onClick={handleConfirm}
            className={cn(
              'h-11 rounded-xl bg-zinc-900 text-white text-[15px] font-semibold hover:bg-zinc-800 transition-colors',
              type === 'confirm' ? 'flex-1' : 'w-full max-w-[200px]'
            )}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
